import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Use the custom hook

const AdminRoute: React.FC = () => {
  // Use the custom hook to access context values
  const { user, loading } = useAuth();

  if (loading) {
    // Optional: Show a loading spinner while checking auth state
    return <div>Loading...</div>; // Replace with a proper loading component if available
  }

  // Check if user is logged in AND has the 'administrator' role
  if (user && user.role?.toLowerCase() === "administrator") {
    return <Outlet />; // Render the child route component
  } else {
    // If not logged in or not an admin, redirect to home or login page
    // Redirecting to home might be less jarring than login if already logged in but wrong role
    console.warn("AdminRoute: Unauthorized access attempt.");
    return <Navigate to="/" replace />; // Or redirect to /login
  }
};

export default AdminRoute;
